import { Box, Button, Flex, HStack, Image, Text } from "@chakra-ui/react";
import Wrapper from "../../../common/Wrapper";
import {
  elipse74,
  elipse75,
  elipse76,
  elipse77,
  elipse78,
} from "../../../../assets/exports";
import FastaMoni from "../Comps/FastaMoni";

const TenthLayer = () => {
  return (
    <Wrapper>
      <Box
        gap="2rem"
        flexDir={["column-reverse", "column-reverse", "row", "row"]}
        mt={{ base: "170px", md: "103px" }}
        pt={{ base: "56px", md: "120px" }}
        pb={{ base: "56px", md: "120px" }}
        bgColor="#F5EFF3"
        color="#ffff"
        px={["20px", "50px", "70px", "90px"]}
      >
        <Flex
          bg="#0F172B"
          borderRadius={{ base: "16px", md: "32px" }}
          minH="371px"
          pos="relative"
          overflow="hidden"
          bgImage={{ base: `url(${elipse78})`, md: "" }}
          bgSize="cover"
          bgPosition="top center"
          bgRepeat="no-repeat"
        >
          <Box display={{ base: "none", md: "block" }}>
            <Box pos="relative" left="-200px">
              <HStack>
                <Image src={elipse77} />
                <Image
                  zIndex={5}
                  pos=" relative"
                  left="-280px"
                  src={elipse76}
                />
                <Image pos="absolute" zIndex={4} left="120px" src={elipse75} />
                <Image pos="absolute" left="200px" src={elipse74} />
                <Image pos="relative" left="-130px" zIndex={4} src={elipse74} />
              </HStack>
            </Box>
          </Box>
          <Box
            display={{ base: "", md: "grid" }}
            placeItems="center"
            gridTemplateColumns={{ base: "", md: "1fr 1fr" }}
            top={0}
            bottom={0}
            py={{ base: "67px", md: "unset" }}
            px={["20px", "42px", "57px"]}
            pos={{ base: "unset", md: "absolute" }}
            zIndex={100}
            textAlign={{ base: "center", md: "left" }}
          >
            <Text
              fontSize={["32px", "42px", "52px"]}
              fontWeight={600}
              lineHeight="1.2"
              pb={{ base: "46px", md: "" }}
            >
              Start Your Journey <br /> With Us Now!
            </Text>
            <Box>
              <Text fontSize={{ base: "14px", md: "20px" }} pb="32px">
                Easily create, manage your Business, and eliminate banking
                administrative processes and increase trust.
              </Text>
              <Button
                bgColor="#fff"
                borderRadius="12px"
                boxShadow="md"
                color="#0F172B"
                px="28px"
                height={{ base: "49px", md: "68px" }}
                fontSize={{ base: "14px", md: "20px" }}
                fontWeight={500}
              >
                Explore Our Products
              </Button>
            </Box>
          </Box>
        </Flex>
      </Box>
      <FastaMoni />
    </Wrapper>
  );
};
export default TenthLayer;
